import React, { useState, useEffect } from "react";
import { Offcanvas, Form, Spinner, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../starek.css";
import isEqual from "lodash/isEqual";
import keyBy from "lodash/keyBy";
import omit from "lodash/omit";
import classNames from "classnames";
// import {
//   saveCycle,
//   deleteCycle,
//   saveCycleStage,
//   deleteCycleStage,
// } from "../../services/RepositoryService";
import { gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router";
import CycleStageCard from "../CycleStageCard";
import { create } from "lodash";

function AddCycleOffCanvasWizard(props) {
  const CREATE_ONE_CYCLE = gql`
    mutation CreateOneCycle($data: CycleCreateInput!) {
      createOneCycle(data: $data) {
        id
        name
        description
        created_at
      }
    }
  `;

  const UPDATE_ONE_CYCLE = gql`
    mutation UpdateOneCycle(
      $data: CycleUpdateInput!
      $where: CycleWhereUniqueInput!
    ) {
      updateOneCycle(data: $data, where: $where) {
        id
        name
        description
        updated_at
      }
    }
  `;

  const DELETE_ONE_CYCLE = gql`
    mutation DeleteOneCycle($where: CycleWhereUniqueInput!) {
      deleteOneCycle(where: $where) {
        id
      }
    }
  `;

  const CREATE_ONE_CYCLE_STAGE = gql`
    mutation CreateOneCycleStage($data: CycleStageCreateInput!) {
      createOneCycleStage(data: $data) {
        id
        name
        duration
        is_productive
        description
      }
    }
  `;

  const UPDATE_ONE_CYCLE_STAGE = gql`
    mutation UpdateOneCycleStage(
      $data: CycleStageUpdateInput!
      $where: CycleStageWhereUniqueInput!
    ) {
      updateOneCycleStage(data: $data, where: $where) {
        id
        name
        duration
        is_productive
        description
      }
    }
  `;

  const DELETE_ONE_CYCLE_STAGE = gql`
    mutation DeleteOneCycleStage($where: CycleStageWhereUniqueInput!) {
      deleteOneCycleStage(where: $where) {
        id
      }
    }
  `;

  const navigator = useNavigate();
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [cycleStageCard, setCycleStageCard] = useState([]);
  const [cycleStagesData, setCycleStagesData] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const [deletedStageIds, setDeletedStageIds] = useState([]);
  let isItemModified = false;
  let isItemDeleted = false;
  const isEdit = Boolean(props.item && props.item.id);
  const client = props.starekContext.engineClient;
  const userId = parseInt(props.starekContext?.user?.id ?? 2);

  const [createCycle] = useMutation(CREATE_ONE_CYCLE, { client });
  const [updateCycle] = useMutation(UPDATE_ONE_CYCLE, { client });
  const [deleteCycleGql] = useMutation(DELETE_ONE_CYCLE, { client });

  const [createStage] = useMutation(CREATE_ONE_CYCLE_STAGE, { client });
  const [updateStage] = useMutation(UPDATE_ONE_CYCLE_STAGE, { client });
  const [deleteStage] = useMutation(DELETE_ONE_CYCLE_STAGE, { client });
  useEffect(() => {
    if (!props.show) return;
    setErrorMsg("");
    const item = props.item || null;
    const stages = Array.isArray(item?.cycle_stages) ? item.cycle_stages : [];
    if (item && item.id && stages.length > 0) {
      setCycleStageCard(stages.map((s) => ({ id: s.id, expanded: true })));

      const initial = {};
      stages.forEach((s) => {
        initial[s.id] = {
          id: s.id,
          name: s.name || "",
          duration: Number(s.duration) || 0,
          is_productive: !!s.is_productive,
          description: s.description || "",
        };
      });
      setCycleStagesData(initial);
    } else {
      setCycleStageCard([{ id: Date.now(), expanded: true }]);
      setCycleStagesData({});
    }
    console.log("cycle edit items", props);
  }, [props.show, props.item]);

  const hasAtLeastOneStage = () => {
    const stages = Object.values(cycleStagesData || {});
    if (stages.length < 1) return false;
    return stages.some(
      (s) =>
        s &&
        typeof s.name === "string" &&
        s.name.trim().length > 0 &&
        Number.isFinite(parseInt(s.duration)) &&
        parseInt(s.duration) > 0 &&
        (s.is_productive === true || s.is_productive === false)
    );
  };

  const hasAnyZeroDuration = () => {
    const stages = Object.values(cycleStagesData || {});
    return stages.some(
      (s) =>
        s && Number.isFinite(parseInt(s.duration)) && parseInt(s.duration) === 0
    );
  };

  const resetWizardState = () => {
    setCycleStageCard([{ id: Date.now(), initialExpanded: true }]);
    setCycleStagesData({});
  };

  const handleSave = async (event) => {
    setIsBtnLoading(true);
    event.preventDefault();

    const formData = new FormData(event.target);
    let newErrors = {};
    const cycleName = formData.get("cycle_name")?.trim();
    if (!cycleName) {
      newErrors.name = "Stage name is required";
      console.error("Cycle name is required.");
      setErrorMsg(newErrors);
      setIsBtnLoading(false);
      return;
    }
    if (cycleStageCard.length < 1 || !hasAtLeastOneStage()) {
      props.starekContext.showError(
        "Please add at least one cycle stage with Name, Duration and Type."
      );
      newErrors.stageError =
        "Please add at least one cycle stage with Name, Duration and Type.";
      setErrorMsg(newErrors);
      setIsBtnLoading(false);
      return;
    }
    if (hasAnyZeroDuration()) {
      props.starekContext.showError(
        "Cycle stages must have a duration greater than zero."
      );
      newErrors.stageError =
        "Cycle stages must have a duration greater than zero.";
      setErrorMsg(newErrors);
      setIsBtnLoading(false);
      return;
    }
    console.log("Cycle stages data:", cycleStagesData);
    const formValues = {
      name: formData.get("cycle_name"),
      description: formData.get("cycle_description"),
    };

    try {
      const { data: createRes } = await createCycle({
        variables: {
          data: {
            name: formValues.name,
            description: formValues.description || "",
            plant: { connect: { id: props.starekContext.lastUsedPlant.id } },
            created_by: { connect: { id: userId } },
            updated_by: { connect: { id: userId } },
          },
        },
      });

      const stageSavePromises = Object.values(cycleStagesData).map((stage) =>
        createStage({
          variables: {
            data: {
              name: stage.name || "",
              duration: parseInt(stage.duration) || 0,
              defaultDuration: parseInt(stage.duration) || 0,
              is_productive: stage.is_productive === true,
              description: stage.description || "",
              cycle: { connect: { id: createRes.id } },
              plant: { connect: { id: props.starekContext.lastUsedPlant.id } },
              created_by: { connect: { id: userId } },
              updated_by: { connect: { id: userId } },
            },
          },
        })
      );

      await Promise.all(stageSavePromises);

      isItemModified = true;
      await props.refetch();
      resetWizardState();
      props.closeOffcanvas(isItemModified, null);
    } catch (error) {
      props.starekContext.showError(error);
    } finally {
      setIsBtnLoading(false);
    }
  };

  const normalizeStage = (s = {}) => ({
    id: s.id ?? undefined,
    name: (s.name || "").trim(),
    duration: Number.parseInt(s.duration) || 0,
    is_productive: s.is_productive === true,
    description: (s.description || "").trim(),
  });

  const handleUpdate = async (event) => {
    setIsBtnLoading(true);
    event.preventDefault();
    let newErrors = {};
    const formData = new FormData(event.target);
    const cycleName = formData.get("cycle_name")?.trim() || "test";
    if (!cycleName) {
      newErrors.name = "Cycle Stage name is required.";
      setErrorMsg(newErrors);
      setIsBtnLoading(false);
      return;
    }
    if (cycleStageCard.length < 1 || !hasAtLeastOneStage()) {
      props.starekContext.showError(
        "Please add at least one cycle stage with Name, Duration and Type."
      );
      newErrors.stageError =
        "Please add at least one cycle stage with Name, Duration and Type.";
      setErrorMsg(newErrors);
      setIsBtnLoading(false);
      return;
    }
    if (hasAnyZeroDuration()) {
      props.starekContext.showError(
        "Cycle stages must have a duration greater than zero."
      );
      newErrors.stageError =
        "Cycle stages must have a duration greater than zero.";
      setErrorMsg(newErrors);
      setIsBtnLoading(false);
      return;
    }

    try {
      const { data: updRes } = await updateCycle({
        variables: {
          where: { id: props.item.id },
          data: {
            name: { set: cycleName },
            description: { set: formData.get("cycle_description") || "" },
            updated_by: { connect: { id: userId } },
          },
        },
      });
      const cycle = updRes?.updateOneCycle ?? { id: props.item.id };

      const originals = Array.isArray(props.item?.cycle_stages)
        ? props.item.cycle_stages
        : [];
      const originalById = keyBy(originals.map(normalizeStage), "id");

      const currentMap = cycleStagesData || {};
      const currentStages = Object.values(currentMap).map(normalizeStage);

      const currentIds = new Set(
        Object.values(currentMap)
          .map((s) => s?.id)
          .filter(Boolean)
      );
      const originalIds = new Set(originals.map((s) => s.id));

      const computedToDelete = [...originalIds].filter(
        (oid) => !currentIds.has(oid)
      );
      const explicitToDelete = deletedStageIds;
      const toDelete = Array.from(
        new Set([...computedToDelete, ...explicitToDelete])
      );

      const originalSignatures = new Set(
        originals.map((os) =>
          JSON.stringify({ ...normalizeStage(os), id: undefined })
        )
      );
      const toCreate = currentStages
        .filter((s) => !s.id || !originalById[s.id])
        .map((s) => ({ ...s, id: undefined }))
        .filter(
          (s) =>
            !originalSignatures.has(JSON.stringify({ ...s, id: undefined }))
        );

      const toUpdate = currentStages.filter((s) => {
        if (!s.id || !originalById[s.id]) return false;
        const prev = originalById[s.id];
        return !isEqual(
          { ...normalizeStage(prev), id: undefined },
          { ...s, id: undefined }
        );
      });

      for (const stageId of toDelete) {
        await deleteStage({
          variables: { where: { id: stageId } },
        });
      }

      const ops = [
        ...toUpdate.map((s) =>
          updateStage({
            variables: {
              where: { id: s.id },
              data: {
                name: { set: s.name },
                duration: { set: s.duration },
                defaultDuration: { set: s.defaultDuration },
                is_productive: { set: s.is_productive },
                description: { set: s.description },
                updated_by: { connect: { id: userId } },
              },
            },
          })
        ),
        ...toCreate.map((s) =>
          createStage({
            variables: {
              data: {
                name: { set: s.name },
                duration: { set: s.duration },
                defaultDuration: { set: s.defaultDuration },
                is_productive: { set: s.is_productive },
                description: { set: s.description },
                cycle: { connect: { id: cycle.id } },
                plant: {
                  connect: { id: props.starekContext.lastUsedPlant.id },
                },
                created_by: { connect: { id: userId } },
                updated_by: { connect: { id: userId } },
              },
            },
          })
        ),
      ];
      await Promise.all(ops);

      isItemModified = true;
      await props.refetch();
      setDeletedStageIds([]);
      resetWizardState();
      props.closeOffcanvas(isItemModified, null);
    } catch (error) {
      props.starekContext.showError(error);
    } finally {
      setIsBtnLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteCycleGql({ variables: { where: { id: props.item.id } } });
      isItemDeleted = true;
      await props.refetch();
      resetWizardState();
      props.closeOffcanvas(null, isItemDeleted);
    } catch (error) {
      props.starekContext.showError(error);
    } finally {
      setIsBtnLoading(false);
    }
  };

  const handleDiscardBtnClick = async () => {
    setCycleStageCard([]);
    props.closeOffcanvas && props.closeOffcanvas(null, null);
    navigator(`/cycles`);
    await props.refetch();
  };
  const addNewCycleStageCard = () => {
    setCycleStageCard([...cycleStageCard, { id: Date.now(), expanded: true }]);
  };
  const removeCycleStageCard = (id) => {
    if (cycleStageCard.length <= 1) {
      props.starekContext.showError("At least one cycle stage is required.");
      return;
    }
    setCycleStageCard(cycleStageCard.filter((stage) => stage.id !== id));
    setCycleStagesData((prev) => omit(prev, [id]));
    const wasExisting =
      Array.isArray(props.item?.cycle_stages) &&
      props.item.cycle_stages.some((s) => s.id === id);
    if (wasExisting) {
      setDeletedStageIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
    }
  };

  const updateCycleStage = (id, data) => {
    const isExisting =
      Array.isArray(props.item?.cycle_stages) &&
      props.item.cycle_stages.some((s) => s.id === id);
    setCycleStagesData((prev) => ({
      ...prev,
      [id]: {
        ...(prev[id] || {}),
        ...(isExisting ? { id } : {}),
        ...data,
      },
    }));
  };

  return (
    <>
      <Offcanvas show={props.show} onHide={props.handleClose} placement="end">
        <Offcanvas.Header className="border-bottom" closeButton>
          <Offcanvas.Title>
            {isEdit ? "Edit Cycle" : "Add Cycle"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column">
          <Form
            className="mt-4 font-weight-normal d-flex flex-column flex-grow-1"
            onSubmit={isEdit ? handleUpdate : handleSave}
          >
            <Form.Group className="mb-3" controlId="cycle_name">
              <Form.Label>
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter here"
                name="cycle_name"
                defaultValue={props.item ? props.item.name : ""}
              />
            </Form.Group>
            {errorMsg.name && (
              <div className="text-danger">{errorMsg.name}</div>
            )}
            <Form.Group className="mb-3" controlId="cycle_description">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Max allowed characters: 120"
                name="cycle_description"
                defaultValue={props.item ? props.item.description : ""}
              />
            </Form.Group>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div>Cycle Stages</div>
              <div
                className="text-primary cursor-pointer"
                onClick={addNewCycleStageCard}
              >
                <i className="fa fa-plus me-2"></i>
                Add new
              </div>
            </div>
            {cycleStageCard.map((stage) => (
              <CycleStageCard
                key={stage.id}
                id={stage.id}
                expanded={!!stage.expanded}
                disableDelete={cycleStageCard.length <= 1}
                removeCycleStage={removeCycleStageCard}
                updateCycleStage={updateCycleStage}
                initialData={cycleStagesData[stage.id]}
              />
            ))}
            {errorMsg.stageError && (
              <div className="text-danger tw-mt-2">{errorMsg.stageError}</div>
            )}
            {errorMsg.stageError && (
              <div className="text-danger tw-mt-2">{errorMsg.stageError}</div>
            )}
            <div
              className={classNames(
                "d-flex align-items-center border-top pt-2 mt-auto",
                {
                  "justify-content-between": isEdit,
                  "justify-content-end": !isEdit,
                }
              )}
            >
              {props.item && (
                <div
                  className="text-danger"
                  style={{ cursor: "pointer" }}
                  onClick={handleDelete}
                >
                  Delete
                </div>
              )}
              <div>
                <Button
                  variant="outline-danger"
                  id="cancel"
                  onClick={handleDiscardBtnClick}
                >
                  Discard
                </Button>
                <Button
                  className="ms-2"
                  variant="primary"
                  id="cycle_submit"
                  type="submit"
                  disabled={isBtnLoading}
                >
                  {isBtnLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}{" "}
                  {props.item ? "Update" : "Save & Add"}
                </Button>
              </div>
            </div>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AddCycleOffCanvasWizard;
